fourToldApp.controller('init', function (xmppAuth, esb, services, $sce, $scope, $rootScope, $filter, $cookieStore, $localStorage, $sessionStorage, $mdDialog, $window, $mdToast, theme, conversation_history, $interval, $location, storage, $locale, cryptool) {
  var xmpp_domain = cryptool.decryptData($window.sessionStorage.getItem("serviceName"));
  var xmppUser = $window.sessionStorage.getItem('userXmpp');
  var interval;
  $window.sessionStorage.removeItem('registerTag')
  $window.sessionStorage.removeItem("viewTemplate");
  window.onpopstate = function (e) { window.history.forward(1); }
  $scope.start = 0;
  $scope.dateMsg = undefined;
  $scope.metadataObj = undefined;
  $scope.imagen = "acount";
  $scope.typeSelect = undefined;
  $scope.simple = true;
  $scope.docFile = null;
  $scope.picFile = null;
  $scope.theme = theme.getTheme();
  $scope.decimalSeparator = $localStorage.decimalSeparator || ',';
  $scope.groupSeparator = $localStorage.groupSeparator || '.';
  $scope.user = services.user.getPhoto();
  $scope.messages = [];
  $scope.hideMenu = $location.search()._managed == '2';
  var userData = services.user.getData();
  $scope.showCancelLoan = userData ? userData.entity.status = 'OK' : undefined;
  $localStorage.msgUnread = 0;
  let notGrantedLocationQuestion = false;
  $localStorage.selectedIndex = 'item-0';

  function loadModelInBackground() {
    console.log("Loading Model")
    $window.sessionStorage.setItem('model_loaded', "1");
    tf.ready().then(() => {
      faceLandmarksDetection.load(
        faceLandmarksDetection.SupportedPackages.mediapipeFacemesh,
        {
          runtime: 'mediapipe',
          solutionPath: 'https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh',
          maxFaces: 1
        }
      ).then(mdl => {
        console.log("Model Loaded")
        $window.sessionStorage.setItem('model_loaded', "1");
      }).catch(err => {
        console.log("Error loading model")
        console.log(err)
        $window.sessionStorage.setItem('model_loaded', "0");
      });
    });

  }

  var messageIntervalId = 0;
  loadModelInBackground()
  if ($location.search().offline) {
    messageIntervalId = $interval(() => {
      getMessages()
    }, 4000)
  }

  $scope.$on('$destroy', function () {
    console.log("cancel messageIntervalId")
    $interval.cancel(messageIntervalId)
  });

  $scope.$watch('DateInit', function (newval, oldval) {
    $scope.count = $scope.count + 1;
  });

  function getMessages() {
    services.offline('bearer ' + $window.localStorage.getItem('access_token1')).getNext({}, {}, function (response) {

      var haveMessages = response.haveMessages

      var messages = $localStorage.msg

      var messageExist = messages && messages.find((item) => item.id == response.data.body.id)

      if (messageExist) {
        haveMessages = false
      }
      else {
        haveMessages = true
      }

      if (haveMessages) {
        var elems = response.data
        $localStorage.chatState = "body";

        var message = { text: elems.body.message, body: elems.body, date: new Date(elems.body.timestamp), metadataObj: elems.metadata, metadata: elems.metadata, id: elems.body.id, layout: "start", isAction: (elems.type === "ACTION") };
        if (elems.metadata != null && elems.metadata.help != null && elems.metadata.instruction != null && elems.metadata.instruction.silent === true) {
          $rootScope.$broadcast('msgRecievedBroadcastHelp', message);
        }
        else {
          if (elems.metadata.processControl)
            $window.localStorage.setItem('aga_status', JSON.stringify(elems));
          else if (!elems.metadata.processControl && $window.localStorage.getItem('aga_status'))
            $window.localStorage.removeItem('aga_status');

          if ($localStorage.msg)
            $localStorage.msg.push(message);
          else {
            var msgArray = [{ text: elems.body.message, body: elems.body, date: new Date(elems.body.timestamp), metadataObj: elems.metadata, metadata: elems.metadata, id: elems.body.id, layout: "start", isAction: (elems.type === "ACTION") }]
            $localStorage.msg = msgArray;
          }
          message["isNew"] = true;
          $rootScope.$broadcast('msgRecievedBroadcast', message);
          $rootScope.$broadcast('msgUnread', "dashboard");
          if (elems.metadata.help && elems.metadata.constraints == null)
            $rootScope.$broadcast('msgRecievedBroadcastHelp', message);
        }
        var metadata = response.data.metadata
        if (metadata.defaultValue == "OFFLINE_START")
          xmppAuth.Chat.sendMessage(xmppUser + "@" + xmpp_domain, JSON.stringify(message), "El Flujo se ha completado. Gracias.", "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);

      } else {
        if (response.isEmpty) {
        }
      }

    })
  }


  var showAlert = function (message) {
    $mdDialog.show(
      $mdDialog.alert()
        .parent(angular.element(document.querySelector('#popupContainer')))
        .clickOutsideToClose(false)
        .textContent(message)
        .ok('Ok')
        .ariaLabel('Alert Dialog')
    ).then(function () {
      if (document.getElementById("inputSimple"))
        document.getElementById("inputSimple").focus();
    })
  };

  $scope.menuItemClickListener = function (index) {
    $scope.sendMessageBasic("Cancelar crédito")
  }


  function positionUpdate(metadataObj, showLockMessage, messageContent) {

    navigator.geolocation.getCurrentPosition(
      function (position) {
        $window.localStorage.setItem("locationPermission", "true");
        $mdDialog.hide();

        var gpsData = {}
        gpsData[metadataObj.instruction.gps.targets.permissionGranted] = true;
        gpsData[metadataObj.instruction.gps.targets.latitude] = position.coords.latitude;
        gpsData[metadataObj.instruction.gps.targets.longitude] = position.coords.longitude;
        var url = "https://maps.googleapis.com/maps/api/geocode/json?latlng=" + position.coords.latitude + "," + position.coords.longitude + "&key=AIzaSyCuHOsgmgIRKiBV9BAuh06wQN4Hb-lfV14&&sensor=true&callback=initMap";
        fetch(url)
          .then(response => response.text())
          .then(contents => {
            var data = JSON.parse(contents);

            if (data.results[0]) {

              gpsData[metadataObj.instruction.gps.targets.address] = data.results[0].formatted_address;

              for (var i = 0; i < data.results[0].address_components.length; i++) {
                if (data.results[0].address_components[i].types[0] == "administrative_area_level_2")
                  gpsData[metadataObj.instruction.gps.targets.city] = data.results[0].address_components[i].long_name;

              }
              $window.sessionStorage.setItem('entityValues', JSON.stringify(gpsData));

            }
          });

        $window.sessionStorage.setItem('entityValues', JSON.stringify(gpsData));
      },
      function (err) {

        switch (err.code) {
          // PERMISSION_DENIED
          case 1:
            console.log('Permission denied')

            if (showLockMessage) {
              var contentMessage = metadataObj.instruction.gps.permissionContent;
              if (messageContent != null)
                contentMessage = messageContent;
              if (metadataObj.instruction.gps.validation === 'MANDATORY') {
                var confirm = $mdDialog.confirm()
                  .title(metadataObj.instruction.gps.permissionTitle)
                  .htmlContent(contentMessage)
                  .ariaLabel('Lucky day')
                  .ok(metadataObj.instruction.gps.permissionAccept);

              }
              else {
                var confirm = $mdDialog.confirm()
                  .title(metadataObj.instruction.gps.permissionTitle)
                  .htmlContent(contentMessage)
                  .ariaLabel('Lucky day')
                  .cancel(metadataObj.instruction.gps.permissionReject)
                  .ok(metadataObj.instruction.gps.permissionAccept);

              }

              $mdDialog.show(confirm).then(function () {

                if (!$window.localStorage.getItem("locationPermission") || $window.localStorage.getItem("locationPermission") == 'lock') {
                  positionUpdate(metadataObj, true, metadataObj.instruction.gps.permissionError);
                }

              }, function () {

              });

            }
            else {

              if ($window.localStorage.getItem("locationPermission") == 'lock') {
                $mdDialog.cancel();
                if (showLockMessage)
                  showAlert(metadataObj.instruction.gps.permissionError);
              }
              else {
                $mdDialog.cancel();
                if (!notGrantedLocationQuestion)
                  positionUpdate(metadataObj, true, metadataObj.instruction.gps.permissionError);

              }
            } { }
            break
          // POSITION_UNAVAILABLE
          case 2:
            console.log('Permission allowed, location disabled')
            break
          // TIMEOUT
          case 3:
            console.log('Permission allowed, timeout reached')
            break
        }
        $window.localStorage.setItem("locationPermission", "lock");
        var gpsData = {}
        gpsData[metadataObj.instruction.gps.targets.permissionGranted] = false;
        console.log(gpsData);
        $window.sessionStorage.setItem('entityValues', JSON.stringify(gpsData));


      }
    );
  }

  function checkGpsMetadata(metadataObj) {
    if (metadataObj.instruction && metadataObj.instruction.gps) {
      var contentMessage = metadataObj.instruction.gps.permissionContent + " <br> Para activar los permisos necesarios, puede ver las instrucciones <a href='https://www.youtube.com/watch?v=_JF3Sx8i7qk&amp;ab_channel=4toldfintech' target=\"_blank\">aqu&iacute;</a>";

      if (metadataObj.instruction.gps.validation === 'MANDATORY') {
        var confirm = $mdDialog.confirm()
          .title(metadataObj.instruction.gps.permissionTitle)
          .htmlContent(contentMessage)
          .ariaLabel('Lucky day')
          .ok(metadataObj.instruction.gps.permissionAccept);

      }
      else {
        var confirm = $mdDialog.confirm()
          .title(metadataObj.instruction.gps.permissionTitle)
          .htmlContent(contentMessage)
          .ariaLabel('Lucky day')
          .cancel(metadataObj.instruction.gps.permissionReject)
          .ok(metadataObj.instruction.gps.permissionAccept);

      }

      var showLockMessage = false;

      if (!$window.localStorage.getItem("locationPermission")) {

        $mdDialog.show(confirm).then(function () {
          if (!$window.localStorage.getItem("locationPermission"))
            checkGpsMetadata(metadataObj);



        }, function () {
          notGrantedLocationQuestion = true;
          var gpsData = {}
          gpsData[metadataObj.instruction.gps.targets.permissionGranted] = false;
          $window.sessionStorage.setItem('entityValues', JSON.stringify(gpsData));
        });
      }
      else {
        if ($window.localStorage.getItem("locationPermission") && $window.localStorage.getItem("locationPermission") == 'lock') {
          showLockMessage = true;
          // positionUpdate(metadataObj,true);
        }


      }

      positionUpdate(metadataObj, showLockMessage, null);



    }
  }


  $scope.sendMessageBasic = function (msg) { //message NLP
    if ($window.localStorage.getItem('aga_status') && JSON.parse($window.localStorage.getItem('aga_status')).metadata.processControl.status === "PROCESSING"
      && msg.toUpperCase() !== "CANCELAR CRÉDITO") {
      var data = JSON.parse($window.localStorage.getItem('aga_status'));
      let msgTime =  new Date($localStorage.msg[$localStorage.msg.length - 1].date);
      let timeObject = new Date(msgTime.getTime() + data.metadata.processControl.timeout * 1000);
      if (new Date() < timeObject) {
        var processControlmessage = data.metadata.processControl.message || "Estamos procesando su respuesta, espere por favor...."
        showAlert(processControlmessage);
      } else {
        xmppAuth.Chat.sendMessage(xmppUser + "@" + xmpp_domain, msg, msg, "sent", "BASIC", undefined, xmpp_domain);
        $scope.newMessageInput = undefined;
      }
    }
    else {
      xmppAuth.Chat.sendMessage(xmppUser + "@" + xmpp_domain, msg, msg, "sent", "BASIC", undefined, xmpp_domain);
      $scope.newMessageInput = undefined;
    }
  }

  $scope.$on('go', function () {
    var size = parseInt($window.sessionStorage.getItem('originalPageCount') || 0);
    var countRow = parseInt($window.sessionStorage.getItem('conversationsCount')) - size;
    if ($window.sessionStorage.getItem('conversationsCount') !== '0' && countRow > 0) {
      $rootScope.progressCircular = true;
      $scope.scrollBottom = undefined;
      var positionScroll = undefined;
      if (countRow > 60) {
        countRow = 60;
        positionScroll = 59;
      } else positionScroll = countRow - 1;

      services.conversation_history('bearer ' + $window.localStorage.getItem('access_token1')).request({
        start: size,
        maxRows: countRow
      }, {}, function (response) {
        $window.sessionStorage.setItem('originalPageCount', parseInt($window.sessionStorage.getItem('originalPageCount') || 0) + response.conversations.length);
        conversation_history.setChatData(response, $scope.messages, undefined, positionScroll);
        $localStorage.msg = $scope.messages;
      });
    }
  });

  $scope.renderHtml = function (htmlCode) {
    try {
      return $sce.trustAsHtml(htmlCode);

    } catch (error) {
      //console.error(console.error());
    }
  };

  $scope.startInterval = function () {
    $scope.stop();
    interval = $interval(function () {
      $scope.safeApply($scope.checkAckFilter());
    }, 10000);
  };

  $scope.stop = function () {
    $interval.cancel(interval);
  };

  $scope.$on('$destroy', function () {
    $scope.stop();
  });

  $scope.$on("msgRecievedBroadcast", function (event, data, type) {
    switch (type) {
      case "ack":
        $scope.safeApply($scope.msgACK(data));
        break;
      case "composing":
        $scope.safeApply($scope.msgComposing());
        break;
      default:
        $scope.safeApply($scope.messageReceive(data));
        if (interval && interval.$$state.status === 2)
          $scope.startInterval();
        if (!interval) {
          $scope.startInterval();
        }
        break;
    }
  });

  $scope.$on("msgRecievedBroadcastHelp", function (event, data) {
    console.log("Notifier ayuda...")
    $scope.helpTourFromNotifier(data)
  });

  $scope.checkAckFilter = function () {
    var filter = $filter('filter')($scope.messages, "check.png");
    if (filter.length > 0) {
      var date = new Date();
      for (var i = 0; i < filter.length; i++) {
        var delayed = date - new Date(filter[i].date);
        if (filter[i].ack === false && delayed > 20000) {
          filter[i].icon = "err_red.png";
          filter[i].retry = true;
        }
      }
    }
  },

    $scope.checkAck = function () {
      const verification = $scope.messages.find(msg => msg.ack === false && msg.icon == "check.png");
      if (verification !== undefined) {
        var date = new Date();
        for (var i = 0; i < $scope.messages.length; i++) {
          var delayed = date - $scope.messages[i].date;
          if ($scope.messages[i].ack === false && delayed > 20000) {
            $scope.messages[i].icon = "err_red.png";
            $scope.messages[i].retry = true;
          }
        }
      } else $scope.stop();
    }

  $scope.msgACK = function (data) {
    const resultado = $scope.messages.find(msg => msg.id === data);
    if (resultado !== undefined) {
      resultado.icon = "checkblue.png";
      resultado.ack = true;
    }
  }

  $scope.msgComposing = function () {
    $scope.procesando = true;
  }

  $scope.safeApply = function (fn) {
    var phase = this.$root.$$phase;
    if (phase === '$apply' || phase === '$digest') {
      if (fn && (typeof (fn) === 'function')) {
        fn();
      }
    } else {
      this.$apply(fn);
    }
  }

  if ($localStorage.msg) {
    $scope.scrollBottom = "bottom";
    Array.prototype.push.apply($scope.messages, $localStorage.msg);

    storage.setLocalStorages($localStorage.msg[$localStorage.msg.length - 1]);
    if ($window.localStorage.getItem("metadataObj") && $window.localStorage.getItem("metadataObj") !== "undefined") {
      $scope.metadataObj = JSON.parse($window.localStorage.getItem("metadataObj"));

      if ($scope.metadataObj.instruction && $scope.metadataObj.instruction.gps)
        showAlert('Verificando información');
      $mdDialog.hide();
      checkGpsMetadata($scope.metadataObj);
    }

    for (var j = 0; j < $scope.messages.length; j++) {
      var data = $scope.messages[j];
      if (data.metadataObj && data.metadataObj.constraints && data.metadataObj.constraints.disableRetry === true) {
        for (var i = 0; i < $scope.messages.length; i++) {
          if ($scope.messages[i].metadataObj && $scope.messages[i].metadataObj.instruction && $scope.messages[i].metadataObj.instruction.retrydefault) {
            $scope.messages[i].metadataObj.instruction.retrydefault = false;

          }
        }
      }
    }

  }

  $scope.questionsDialog = function (ev) {
    if ($window.sessionStorage.getItem('needConfigureQuestions') === "true" && $window.localStorage.getItem('access_token1')) {
      $scope.quentions = services.configuration_securityQuentions('bearer ' + $window.localStorage.getItem('access_token1')).getQuestions({}, {}, function (response) {
        if (response.code === 2 || response.data.length === 0) {
          $window.sessionStorage.removeItem("needConfigureQuestions");
        } else {
          $mdDialog.show({
            locals: { dataToPass: response, showFileChoose: 0 },
            templateUrl: 'views/dashboard/security_questions.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            controller: 'quentionsCntrl',
            clickOutsideToClose: false
          });
        }
      });
    }
  }

  $scope.action = function (metadata, ev) {
    switch (metadata.action) {
      case "newLoan":
        metadata.windowTitle = metadata.windowTitle || "Selecciona el crédito que deseas";
        if (metadata.lenderList.length > 0)
          entityLoans(ev);
        else showAlert("El sistema no puede asociar programas de créditos adecuado a tu perfil, uno de nuestros ejecutivos te estará contactando para validar tu información")
        break;
      case "signature":
        $scope.signature(ev);
        break;
      case "requestAction":
        $scope.requestAction(metadata, ev, false);
        break;
      case "homeAddress":
        $scope.homeAddress(ev);
        break;
      case "requestSignature":
        $scope.requestSignature(ev);

        break;
      case "showGuarantorOffer":
        showGuarantorOffer(ev);
        break;
    }
    //showGuarantorOffer(ev);
  }

  $scope.showConfirm = function (ev) {
    $scope.disabledBtn = true;
    var confirmDialog = $scope.metadataObj.instruction;
    $window.sessionStorage.setItem("confirmDialog", JSON.stringify(confirmDialog));

    var confirm = $mdDialog.show({
      controller: 'list',
      templateUrl: 'selectList.html',
      parent: angular.element(document.body),
      targetEvent: ev
    }).then(function (answer) {
    }, function () {
      $scope.disabledBtn = false;
    });
    if (ev) {
      $scope.typeSelect = 1;
    }
  };


  function entityLoans(ev) {
    $mdDialog.show({
      controller: 'loanCntrl',
      templateUrl: 'loanList.html',
      parent: angular.element(document.body),
      targetEvent: ev
    }).then(function (answer) {
    }, function () {
      $scope.disabledBtn = false;
    });
    if (ev) {
      $scope.typeSelect = 1;
    }
  };

  $scope.signature = function (ev) {
    var confirm = $mdDialog.show({
      controller: 'signatureCntrl',
      templateUrl: 'signature.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      fullscreen: true,
    }).then(function (answer) {
    }, function () {
      $scope.disabledBtn = false;
    });
  };

  $scope.requestAction = function (metadata, ev, automatic) {
    if (metadata.constraints && metadata.constraints.type == "logout") {
      let constraints = metadata.constraints;
      let waitSeconds = 1000; // default values
      let managedSessionMessage = ''; // default values
      if (constraints.config) {
        let config = constraints.config;
        waitSeconds = config.waitSeconds || config.waitSeconds == 0 ? config.waitSeconds : waitSeconds; // notifier config or default values
        managedSessionMessage = config.label || managedSessionMessage; // notifier config or default values
      }
      if (!automatic) { // action triggered by user, not by an incoming message received
        waitSeconds = 0;
      }
      console.log('logging out in ' + (waitSeconds / 1000) + ' seconds');
      setTimeout(function () {
        $rootScope.managedSessionMessage = managedSessionMessage;
        angular.element(document.getElementById('footerMenu')).scope().logout();
      }, waitSeconds);
    }
  };

  $scope.requestSignature = function (ev) {
    var confirm = $mdDialog.show({
      controller: 'signatureCntrl',
      templateUrl: 'signContract.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      fullscreen: true,
    }).then(function () {
    }, function () {
      $scope.disabledBtn = false;
    });
  };

  function showGuarantorOffer(ev) {

    var metadataGuarantor = JSON.parse($window.localStorage.getItem('metadataObj'));
    var templateUrl = './views/dashboard/guarantorOffer.html';
    if (metadataGuarantor != null && metadataGuarantor.extra != null && metadataGuarantor.extra.length > 0) {
      var extra = JSON.parse(metadataGuarantor.extra)
      if (extra != null && extra.ui != null) {
        templateUrl = './views/dashboard/guarantorOfferDynamic.html';

      }

    }

    $mdDialog.show({
      controller: 'guarantorCntrl',
      templateUrl: templateUrl,
      parent: angular.element(document.body),
      targetEvent: ev,
      fullscreen: true,
    }).then(function () {
    }, function () {
      $scope.disabledBtn = false;
    });
  };

  $scope.homeAddress = function (ev) {
    var confirm = $mdDialog.show({
      controller: 'addressCntrl',
      templateUrl: 'address.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      fullscreen: true,
    }).then(function (answer) {
    }, function () {
      $scope.disabledBtn = false;
    });
  };

  $scope.listCheckbox = function (ev) {
    var confirm = $mdDialog.show({
      controller: 'list',
      templateUrl: 'selectListMultiple.html',
      parent: angular.element(document.body),
      targetEvent: ev
    }).then(function (answer) {
    }, function () {
      $scope.disabledBtn = false;
    });
    if (ev) {
      $scope.typeSelect = 1;
    }
  };

  $scope.msg_date_menu = function (fecha, msg, url, format) {

    var dateMenu = undefined;
    var date = new Date();
    date = $filter('date')(date, "dd/MM/yyyy");
    var dateMsg = $filter('date')(fecha, "dd/MM/yyyy");

    if (date === dateMsg)
      dateMenu = $filter('date')(fecha, "h:mm a");
    else dateMenu = dateMsg;

    if (url) {
      if (format === 'jpg' || 'png' || 'image')
        $window.sessionStorage.setItem("msg", "Imagen enviada");
      else
        $window.sessionStorage.setItem("msg", "Documento enviado");
    }
    else
      $window.sessionStorage.setItem("msg", msg);

    $cookieStore.put('hora', dateMenu, {});
  };

  $scope.checkDate = function (date, index, messages) {
    $scope.dateTest = $filter('date')(messages[index].date, "dd/MM/yyyy");
    if (index > 1) {
      var dateGeneral = $filter('date')(messages[index - 1].date, "dd/MM/yyyy");
    }
    return $scope.dateTest;
  };


  $scope.showDatePicker = function (ev) {
    $scope.disabledBtn = true;
    var confirm = $mdDialog.show({
      controller: 'date',
      controllerAs: 'ctrl',
      templateUrl: 'datePicker.html',
      parent: angular.element(document.body),
      targetEvent: ev
    }).then(function (answer) {
    }, function () {
      $scope.disabledBtn = false;
    });
  };
  $scope.$watch("assignments", function (value) {//I change here

    $('#timepicker').mdtimepicker({ format: 'h:mm tt', hourPadding: true }, 'show');

  });
  $scope.sendTimeMsg = function () {
    xmppAuth.Chat.sendMessage(xmppUser + "@" + xmpp_domain, $scope.time, $scope.time, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);
    $scope.newMessageInput = undefined;
  };

  $scope.showTimePickerClick = function (ev) {
    $('#timepicker').mdtimepicker().on('timechanged', function (e) {
      $scope.time = e.value.toLowerCase();
      $scope.sendTimeMsg();
    });
  };

  $scope.showTimePicker = function (ev) {
    $('#timepicker').mdtimepicker({ format: 'h:mm tt', hourPadding: true }, 'show');
    return $scope.metadataObj && $scope.metadataObj.constraints && $scope.metadataObj.constraints.type === 'Time';
  };

  $scope.helpTour = function (ev) {
    var messages = $localStorage.msg;
    var lastMessage = messages[messages.length - 1];
    var help = lastMessage.metadata.help;
    var confirm = $mdDialog.show({
      locals: { dataToPass: null, showFileChoose: 0 },
      controller: 'helpTourCntrl',
      templateUrl: './views/dashboard/helpTour.html',
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      fullscreen: true,
      escapeToClose: true,
      targetEvent: ev
    }).then(function (answer) {
      $scope.modalCamera();
    }, function () {
      $scope.disabledBtn = false;
    });
  };

  $scope.helpTourFromNotifier = function (data) {
    $mdDialog.show({
      locals: { dataToPass: data },
      controller: 'helpTourCntrl',
      templateUrl: './views/dashboard/helpTour.html',
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      fullscreen: true,
      escapeToClose: true,
    });
  };


  $scope.showImagePreview = function (ev) {
    if (ev.currentTarget.files !== undefined) {
      //if(ev.currentTarget.files[0].type.includes($scope.metadataObj.constraints.format) === true){
      if (ev.currentTarget.files[0].type === 'image/jpeg' || ev.currentTarget.files[0].type === 'image/png') {
        $scope.disabledBtn = true;
        var confirm = $mdDialog.show({
          templateUrl: 'imagePreview.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          locals: { dialogLocals: { picFile: ev.currentTarget.files[0] } },
          controller: 'image'
        }).then(function (answer) { }, function () {
          $scope.disabledBtn = false;
        });
      }
      else {
        $scope.docFile = undefined;
        $scope.progressCircular = undefined;
        $scope.msgToast("El archivo debe ser una imagen de tipo jpeg/png", "error-toast");
      }
    }
  };

  $scope.checkTypeFile = function (data) {
    var format = data.constraints.format.split(",")
    var exts = new Array()

    for (const it of format) {
      exts.push("." + it)
    }

    var extensions = exts.join(",")

    switch (data.constraints.format) {
      case "pdf":
        $scope.file = "application/pdf"
        break;
      case "image":
        $scope.file = "image/*"
        break;
      default:
        $scope.file = extensions
        break;
    }
    return $scope.file;
  }

  $scope.uploadFiles = function (ev) {
    if (ev.currentTarget.files !== undefined) {
      //if(ev.currentTarget.files[0].type.includes($scope.metadataObj.constraints.format) === true)
      if (true) {
        $scope.disabledBtn = true;
        var confirm = $mdDialog.confirm()
          .textContent('Desea enviar archivo "' + ev.currentTarget.files[0].name + '" ?')
          .ariaLabel('enviar')
          .targetEvent(ev)
          .ok('Enviar')
          .cancel('Cancelar');
        $mdDialog.show(confirm).then(function () {
          $scope.progressCircular = "ok";
          //$scope.showAlert()
          var payload = new FormData();
          //var format = ev.currentTarget.files[0].type.split("/");
          payload.append("file", ev.currentTarget.files[0]);
          payload.append('type', $scope.metadataObj.constraints.imageType);
          payload.append('latitude', "1");
          payload.append('longitude', "1");
          services.user.userServices('bearer ' + $window.localStorage.getItem('access_token1')).uploadReceipt({}, payload, function (response, event) {
            //$scope.closeDialog();
            $scope.progressCircular = undefined;
            if (response.data.url) {
              var message = { text: ev.currentTarget.files[0].name, url: esb + "/security" + response.data.url, type: "sent", layout: "end", format: $scope.metadataObj.constraints.format, typeDocument: "File" }
              var value = "{\"code\":\"1\",\"format\":\"" + $scope.metadataObj.constraints.format + "\",\"imageCapture\":\"mandatory\",\"imageType\":\"externalPaymentReceipt\",\"type\":\"File\",\"url\":\"" + esb + "/security" + response.data.url + "\"}";
              xmppAuth.Chat.sendMessageImage(xmppUser + "@" + xmpp_domain, "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain, message, value);
              $scope.metadataObj = undefined;
            }
          });
        }, function () { $scope.docFile = undefined; });
      }
      //   else {
      //         $scope.docFile = undefined;
      //         $scope.progressCircular = undefined;
      //         $scope.msgToast("El archivo debe ser un " + $scope.metadataObj.constraints.format, "error-toast");
      // }
    }
  };



  $scope.closeDialog = function () {
    $mdDialog.cancel();
  };


  $scope.cameraTour = function (ev) {
    var confirm = $mdDialog.show({
      locals: {
        isInit: false,
        isAudio: false,
        isVideo: true
      },
      controller: 'cameraTourCntrl',
      templateUrl: './views/dashboard/cameraTour.html',
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      fullscreen: true,
      escapeToClose: true,
      targetEvent: ev
    }).then(function (answer) {

    }, function () {

    });
  };


  function cameraPermission(ev, nextCall) {
    nextCall(ev)
  }


  $scope.modalCameraDialog = function (ev) {
    var confirm = $mdDialog.show({
      controller: 'camera',
      templateUrl: './views/dashboard/camera.html',
      parent: angular.element(document.body),
      targetEvent: ev
    }).then(function (answer) {
    }, function () {
      $scope.disabledBtn = false;
    });
  }

  $scope.modalCamera = function (ev) {
    cameraPermission(ev, $scope.modalCameraDialog)
  }
  $scope.clickUp = function () {
    setTimeout(function () {
      document.getElementById("file").click()
      $scope.disabledBtn = false;
    }, 0);
  };
  $scope.helpTourImage = function (ev) {
    var messages = $localStorage.msg;
    var lastMessage = messages[messages.length - 1];
    var help = lastMessage.metadata.help;
    var confirm = $mdDialog.show({
      locals: { dataToPass: null, showFileChoose: 0 },
      controller: 'helpTourCntrl',
      templateUrl: './views/dashboard/helpTour.html',
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      escapeToClose: true,
      targetEvent: ev
    }).then(function (answer) {
      $scope.clickUp();
    }, function () {
      $scope.disabledBtn = false;
    });
  };

  $scope.showModalImage = function (ev) {
    $scope.disabledBtn = true;
    var messages = $localStorage.msg;
    var lastMessage = messages[messages.length - 1];
    var help = lastMessage.metadata.help;

    if (help) {
      $scope.helpTourImage(ev)
    }
    else {
      $scope.clickUp();
    }
  };

  $scope.helpTourGallery = function (ev) {

    var messages = $localStorage.msg;
    var lastMessage = messages[messages.length - 1];
    var help = lastMessage.metadata.help;
    var confirm = $mdDialog.show({
      locals: { dataToPass: null, showFileChoose: 100 },
      controller: 'helpTourCntrl',
      templateUrl: './views/dashboard/helpTour.html',
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      fullscreen: true,
      escapeToClose: true,
      targetEvent: ev
    }).then(function (answer) {
    }, function () {
      $scope.disabledBtn = false;
    });


  };

  $scope.shouldShowHelp = function () {
    var messages = $localStorage.msg;
    var lastMessage = messages[messages.length - 1];
    var help = lastMessage.metadata.help;
    if (help) {
      $scope.helpTourGallery()
    }
    else {
      $("#file").click();
    }
  }

  $scope.validateBarcode = function (ev, data) {
    switch (data) {
      case "barcode":
        var confirm = $mdDialog.show({
          controller: DialogController,
          template: '<md-dialog class="dialogBarcode">' +
            '  <h4 class="dialogTitleBarcode">Notificación</h4>' +
            '  <md-dialog-content>' +
            '<div class="test"><p>Nuestro chat web no puede escanear tu código de barras en este momento, por favor toma una fotografía de la parte de atrás de tu cédula de ciudadanía con el código de barras.</p></div>' +
            '  </md-dialog-content>' +
            '    <md-dialog-actions layout="row">' +
            '        <md-button class="md-primary" ng-click="answer(\'aceptar\')">' +
            '          Aceptar' +
            '        </md-button>' +
            '    </md-dialog-actions>' +
            '</md-dialog>',
          parent: angular.element(document.body),
          targetEvent: ev
        }).then(function (answer) {
          if (answer === 'aceptar')
            $scope.showModalCamera(ev);
        });
        break;
      default:
        $scope.modalCamera(ev);
    }
  };

  function DialogController($scope, $mdDialog) {
    $scope.hide = function () {
      $mdDialog.hide();
    };

    $scope.cancel = function () {
      $mdDialog.cancel();
    };

    $scope.answer = function (answer) {
      $mdDialog.hide(answer);
    };
  };

  $scope.showModalCamera = function (ev) {
    $scope.disabledBtn = true;
    var messages = $localStorage.msg;
    var lastMessage = messages[messages.length - 1];
    var help = lastMessage.metadata.help;

    if (help) {
      $scope.helpTour(ev)
    }
    else {
      $scope.modalCamera();
    }
  };

  $scope.pendingSend = function () { };
  $scope.sendMsg = function () {
    document.getElementById("inputSimple").focus();
    if (document.getElementById("inputSimple").value.trim() !== '') {
      var msg = document.getElementById("inputSimple").value;
      if ($scope.metadataObj && $scope.metadataObj.instruction && $scope.metadataObj.instruction.confirmation) {
        $scope.pendingMessage = {};
        $scope.pendingMessage.id = msg;
        $scope.pendingMessage.value = msg;
        $scope.showConfirmation();
        $scope.pendingSend = function () {
          xmppAuth.Chat.sendMessage(xmppUser + "@" + xmpp_domain, $scope.pendingMessage.id, $scope.pendingMessage.id, "sent", "BASIC", undefined, xmpp_domain);
          $scope.newMessageInput = undefined;
          document.getElementById("inputSimple").value = '';
        }
      }
      else { //message NLP
        if ($window.localStorage.getItem('aga_status') && JSON.parse($window.localStorage.getItem('aga_status')).metadata.processControl.status === "PROCESSING"
          && msg.toUpperCase() !== "CANCELAR CRÉDITO") {
          var data = JSON.parse($window.localStorage.getItem('aga_status'));
          let msgTime =  new Date($localStorage.msg[$localStorage.msg.length - 1].date);
          let timeObject = new Date(msgTime.getTime() + data.metadata.processControl.timeout * 1000);
          if (new Date() < timeObject) {
            var processControlmessage = data.metadata.processControl.message || "Estamos procesando su respuesta, espere por favor...."
            showAlert(processControlmessage);
          } else {
            xmppAuth.Chat.sendMessage(xmppUser + "@" + xmpp_domain, msg, msg, "sent", "BASIC", undefined, xmpp_domain);
            $scope.newMessageInput = undefined;
            document.getElementById("inputSimple").value = '';
          }
        }
        else if (!$window.localStorage.getItem('aga_status') || JSON.parse($window.localStorage.getItem('aga_status')).metadata.processControl.status === "DONE") {
          xmppAuth.Chat.sendMessage(xmppUser + "@" + xmpp_domain, msg, msg, "sent", "BASIC", undefined, xmpp_domain);
          $scope.newMessageInput = undefined;
          document.getElementById("inputSimple").value = '';
        }
      }
    }
  };

  $scope.showConfirmation = function (ev) {
    var confirmDialog = $scope.metadataObj.instruction;
    confirmDialog.response = $scope.pendingMessage.value;
    $window.sessionStorage.setItem("confirmDialog", JSON.stringify(confirmDialog));

    var confirm = $mdDialog.show({
      controller: 'confirmationCntrl',
      templateUrl: './views/dashboard/confirmation.html',
      parent: angular.element(document.body),
      targetEvent: ev
    }).then(function (answer) {
      $scope.pendingSend();
    }, function () {
    });

  };

  $scope.retrySendMessage = function (data) {
    xmppAuth.Chat.retrySendMessage(data, xmpp_domain);
  };

  $scope.sendMsgSelect = function (msg) {
    if ($scope.metadataObj && $scope.metadataObj.instruction && $scope.metadataObj.instruction.confirmation) {
      $scope.pendingMessage = msg;
      $scope.showConfirmation();
      $scope.pendingSend = function () {
        xmppAuth.Chat.sendMessage(xmppUser + "@" + xmpp_domain, $scope.pendingMessage.id, $scope.pendingMessage.value, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);
        $scope.metadataObj = undefined;
        $window.localStorage.setItem('metadataObj', JSON.stringify($scope.metadataObj));
      }
    } else {
      xmppAuth.Chat.sendMessage(xmppUser + "@" + xmpp_domain, msg.id, msg.value, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);
      $scope.metadataObj = undefined;
      $window.localStorage.setItem('metadataObj', JSON.stringify($scope.metadataObj));
    }
  };

  $scope.retryMsg = function (msg) {
    var date = new Date();
    if ($scope.lastActionMessageWasAnswered(msg))
      $window.sessionStorage.setItem('replyType', 'RETRY');
    else
      $window.sessionStorage.removeItem('replyType');

    message = { type: 'RETRY', text: msg.text, date: date, metadataObj: msg.metadata, metadata: msg.metadata, id: msg.id, layout: "start", isAction: msg.isAction };
    $rootScope.$broadcast('msgRecievedBroadcast', message);
  };

  $scope.skipMsg = function () {
    xmppAuth.Chat.sendSkipMsg(xmppUser + "@" + xmpp_domain, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);
    $scope.metadataObj = undefined;
    $scope.newMessage = undefined;
  };

  $scope.sendMsgInputString = function (msg) {

    document.getElementById("stringInput").focus();
    if (msg === undefined || msg.trim() == "")
      $scope.msgToast("Debe enviar una respuesta", "error-toast");
    else {
       if ($scope.metadataObj && $scope.metadataObj.instruction && $scope.metadataObj.instruction.confirmation) {
        $scope.pendingMessage = {};
        $scope.pendingMessage.id = msg;
        $scope.pendingMessage.value = msg;
        $scope.showConfirmation();
        $scope.pendingSend = function () {
          xmppAuth.Chat.sendMessage(xmppUser + "@" + xmpp_domain, $scope.pendingMessage.id, $scope.pendingMessage.id, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);
          $scope.newMessage = undefined;
        }
      } else {
        xmppAuth.Chat.sendMessage(xmppUser + "@" + xmpp_domain, msg, msg, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);
        $scope.newMessage = undefined;
      }
    }
  };

  $scope.sendMsgInputDouble = function (msg) {
    document.getElementById("doubleInput").focus();
    var max = $scope.metadataObj.constraints.max;
    var min = $scope.metadataObj.constraints.min;
    msg = msg.trim();
    if (msg === undefined || msg === null || msg === "")
      $scope.msgToast("Debe ingresar un valor menor o igual a " + $scope.metadataObj.constraints.max, "error-toast");
    else {
      var w = $scope.cleanDouble(msg);
      var message = parseInt(w);
      var value = msg.toString();
      if ($scope.metadataObj.constraints.precision > 2) {
        message = parseFloat(w);
        value = w.toString();
      }

      if (message > max && !(max == 0 && min == 0)) {
        $scope.msgToast("Debe ingresar un valor menor o igual a " + max, "error-toast");
        return;
      }

      if (message < min && !(max == 0 && min == 0)) {
        $scope.msgToast("Debe ingresar un valor mayor o igual a " + min, "error-toast");
        return;
      }
      if ($scope.metadataObj && $scope.metadataObj.instruction && $scope.metadataObj.instruction.confirmation) {
        $scope.pendingMessage = {};
        $scope.pendingMessage.id = msg;
        $scope.pendingMessage.value = msg;
        $scope.showConfirmation();
        $scope.pendingSend = function () {
          xmppAuth.Chat.sendMessage(xmppUser + "@" + xmpp_domain, message, value, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);
          $scope.newMessage = undefined;
        }
      } else {
        xmppAuth.Chat.sendMessage(xmppUser + "@" + xmpp_domain, message, value, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);
        $scope.newMessage = undefined;
      }

    }
  };

  $scope.format = function (num) {
    var decimalSeparator = $scope.decimalSeparator;
    var groupSeparator = $scope.groupSeparator;

    var floatSeparator = ".";
    var minus = false;
    if (num < 0) {
      minus = true;
      num = (-1) * num;
    }
    var str = num.toString().replace("$", ""), parts = false, output = [], i = 1, formatted = null;
    if (str.indexOf(floatSeparator) > 0) {
      parts = str.split(floatSeparator);
      str = parts[0];
    }
    str = str.split("").reverse();
    for (var j = 0, len = str.length; j < len; j++) {
      if (str[j] != groupSeparator) {
        output.push(str[j]);
        if (i % 3 == 0 && j < (len - 1)) {
          output.push(groupSeparator);
        }
        i++;
      }
    }
    formatted = output.reverse().join("");
    result = formatted + ((parts) ? decimalSeparator + parts[1].substr(0, 2) : "");
    result = (minus ? "-" : "") + result;
    return (result);
  };

  $scope.cleanDouble = function (num) {
    var w = num.toString();
    var groupBlocks = w.split($scope.groupSeparator);
    for (var i = 0; i < groupBlocks.length; i++)
      w = w.replace($scope.groupSeparator, "");
    w = w.replace($scope.decimalSeparator, ".");
    return w;
  };

  $scope.formatDouble = function (e, sender) {
    var max = $scope.metadataObj.max;
    var min = $scope.metadataObj.min;
    var avoidFormatting = $scope.metadataObj.constraints.avoidFormatting;
    var decimalSeparator = $scope.decimalSeparator;
    var groupSeparator = $scope.groupSeparator;
    if (e.key == "-" && sender.newMessage.length == 1) {
      return;
    }
    if (e.key == "." || e.key == ",") {
      sender.newMessage = sender.newMessage.replace(/.$/, decimalSeparator)
      return;
    }
    if (e.keyCode == 13 && sender.newMessage !== undefined) {
      $scope.sendMsgInputDouble(sender.newMessage)
    } else {
      /**/
      var oldval = sender.newMessage.substring(0, sender.newMessage.length - 1);
      if (sender.newMessage == "" | sender.newMessage == undefined) {
        document.getElementById("doubleInput").value = "";
        return;
      }
      var w = $scope.cleanDouble(sender.newMessage);
      var parsed = parseFloat(w)
      var numberVal = $scope.format(parsed);
      if (avoidFormatting) numberVal = w;
      if (isNaN(parsed)) numberVal = oldval;
      sender.newMessage = numberVal;
      /**/
    }
  };

  var unbindWatcher = $scope.$watch(function () {
    if ($window.localStorage.getItem("access_token1") === null) {
      $scope.progressCircular = "ok";
      unbindWatcher();
    }
  });

  $scope.$watch(function () {
    if ($localStorage.typeSelect) {
      $scope.metadataObj = undefined;
    }
  });


  $scope.messageReceive = function (data) {
    $scope.procesando = false;
    $window.sessionStorage.removeItem("entityValues");
    if (data.metadataObj) {
      $scope.metadataObj = data.metadataObj;
      $scope.metadataObj["type_meta"] = (data.isAction === true) ? "ACTION" : "BASIC";
      $scope.typeSelect = data.metadataObj;
      $window.localStorage.setItem('metadataObj', JSON.stringify($scope.metadataObj));
      $localStorage.typeSelect = undefined;
      checkGpsMetadata(data.metadataObj);
      if (data.isNew) {
        delete data.isNew
        if ($scope.metadataObj && $scope.metadataObj.constraints && $scope.metadataObj.constraints.type == "updatePassword") {
          $scope.autoOpenPasswordForm($scope.metadataObj)
        } else if ($scope.metadataObj && $scope.metadataObj.constraints && $scope.metadataObj.action == "requestAction") {
          $scope.requestAction($scope.metadataObj, null, true);
        } else {
          $scope.autoOpenDynamicForm($scope.metadataObj)
        }

      }

    } else {
      $scope.metadataObj = undefined;
      $window.localStorage.setItem('metadataObj', undefined);
    }

    if (data.metadata && data.metadata.instruction && data.metadata.instruction.confirmation) {
      $window.sessionStorage.setItem("confirmDialog", JSON.stringify(data.metadata.instruction));
    }
    else {
      $window.sessionStorage.removeItem("confirmDialog");
    }
    if (data.id)
      $window.sessionStorage.setItem('idAga', data.id);

    if (data.body && data.body.constraints && data.body.constraints.formBody || (data.body && data.body.constraints && data.body.constraints.type == "camera_verification")) {
      $window.sessionStorage.setItem("dataNotification", JSON.stringify(data));
    }
    else {
      $window.sessionStorage.removeItem("dataNotification");
    }


    if (data.body && data.body.constraints && data.body.constraints.formBody || (data.body && data.body.constraints && data.body.constraints.type == "updatePassword")) {
      $window.sessionStorage.setItem("dataNotification", JSON.stringify(data));
    }
    else {
      $window.sessionStorage.removeItem("dataNotification");
    }

    if (data.metadataObj && data.metadataObj.constraints && data.metadataObj.constraints.disableRetry === true) {
      for (var i = 0; i < $scope.messages.length; i++) {
        if ($scope.messages[i].metadataObj && $scope.messages[i].metadataObj.instruction && $scope.messages[i].metadataObj.instruction.retrydefault)
          $scope.messages[i].metadataObj.instruction.retrydefault = false;
      }
    }


    if (!$scope.messages.find(msg => msg.id === data.id) || data.type === 'sent' || data.type === 'RETRY') {
      $scope.messages.push(data)
    }
    $localStorage.msg = []
    Array.prototype.push.apply($localStorage.msg, $scope.messages);
    //$localStorage.msg = $scope.messages;
    $scope.scrollBottom = $scope.messages;
    $scope.disabledBtn = false;


  };

  $scope.msgToast = function (message, type) {
    $mdToast.show(
      $mdToast.simple()
        .textContent(message)
        .position('top')
        .action('Ok')
        .theme(type)
        .hideDelay(2000)
    );
  };

  $scope.lastActionMessageWasAnswered = function (message) {
    for (var i = $scope.messages.length - 1; i >= 0; i--) {
      var m = $scope.messages[i];
      var id = m.obj ? m.obj.body.id : m.id;
      if (message.id == id) {
        if (m.type == "sent")
          return true;
        else return false;
      }
    }
  }

  $scope.messageCanShow = function (index) {
    var lastActionIndex = -1;
    var message = $scope.messages[index];
    if (message.metadataObj.instruction.retryConstraint == "PREVIOUS_ONLY") {
      var actionMsgCount = 0;
      for (var i = $scope.messages.length - 1; i >= index; i--) {
        var local = $scope.messages[i];
        if (local.isAction) {
          actionMsgCount++;
          if (lastActionIndex < 0) lastActionIndex = i;
          if (actionMsgCount > 2) return false;
          if (message.id == local.id && index != i) return false;
        }
      }
      var lastActionMessage = $scope.messages[lastActionIndex];

      if ((actionMsgCount < 3) && lastActionMessage && (!$scope.lastActionMessageWasAnswered(lastActionMessage) || ($scope.lastActionMessageWasAnswered(lastActionMessage) && (lastActionMessage.id == message.id))))
        return true;
    } else return true;
  }

  $scope.openDynamicForm = function (ev) {
    if ($window.sessionStorage.getItem("dataNotification")) {
      $location.path("/viewform");
    }
    else {
      showAlert("No existe información del formulario a mostrar");
    }
  };

  $scope.openLifeProofForm = function (ev) {
    var modelLoaded = $window.sessionStorage.getItem('model_loaded');
    if (modelLoaded === "1") {
      console.log("life proof model")
      $location.path("/lifeproof")
    }
    else {
      console.log("life proof no model")
      $location.path("/lifeproofNoModel")
    }
  };

  $scope.openLifeProofFormAws = function (ev) {
    $location.path("/rekognition")
  };

  $scope.openPasswordForm = function (ev) {
    if ($window.sessionStorage.getItem("dataNotification")) {
      $location.path("/passwordform");
    }
    else {
      showAlert("No existe información del formulario a mostrar");

    }
  };

  $scope.autoOpenPasswordForm = function () {
    if ($scope.metadataObj && $scope.metadataObj.constraints && $scope.metadataObj.constraints.autoExec) {

      setTimeout(function () {
        if ($window.sessionStorage.getItem("dataNotification")) {
          $location.path("/passwordform");
        }
        else {
          showAlert("No existe información del formulario a mostrar");
        }
      }, 0)

    }
    return true
  };

  $scope.autoOpenDynamicForm = function () {
    if ($scope.metadataObj && $scope.metadataObj.constraints && $scope.metadataObj.constraints.autoExec) {

      setTimeout(function () {
        if ($window.sessionStorage.getItem("dataNotification")) {
          $location.path("/viewform");
        }
        else {
          showAlert("No existe información del formulario a mostrar");
        }
      }, 0)

    }
    return true
  };


  $scope.showInfo = function (index, metadata) {
    if (!$scope.showItemDetails[index]) {
      $scope.detailsInfo = undefined;
      $scope.showItemDetails[index] = true;
    } else {
      $scope.showItemDetails[index] = false;
      $scope.detailsInfo = "ok";

    }
  };


  $scope.showDetailMessageInBlockSent = function (message) {
    /* $mdDialog.show(
       $mdDialog.alert()
         .parent(angular.element(document.body))
         .title('Información enviada')
         .clickOutsideToClose(false)
         .htmlContent(message)
         .ok('Cerrar')
         .ariaLabel('Alert Dialog')
     ).then(function() {
       if(document.getElementById("inputSimple"))
         document.getElementById("inputSimple").focus();
     })*/
    var messageLocal = message.text;

    if (message.type == 'sent' && message.body != undefined && message.body.formatedMessageInBlock != undefined)
      messageLocal = message.body.formatedMessageInBlock;

    if (message.type == 'sent' && message.obj != undefined && message.obj.body != undefined && message.obj.body.formatedMessageInBlock != undefined)
      messageLocal = message.obj.body.formatedMessageInBlock;
    $mdDialog.show({

      template: '<md-dialog class="dialogBarcode">' +
        '  <h4 layout="row" layout-align="center center" class="dialogTitleBarcode"><strong>Información registrada</strong></h4>' +
        '  <md-dialog-content>' +
        '<div style="min-width: 300px; ">' +
        messageLocal +
        '</div>' +
        '  </md-dialog-content>' +
        '    <md-dialog-actions layout="row">' +
        '        <md-button class="md-primary" ng-click="answer(\'aceptar\')">' +
        '          Cerrar' +
        '        </md-button>' +
        '    </md-dialog-actions>' +
        '</md-dialog>',
      controller: DialogController,
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      fullscreen: false,
      escapeToClose: true,
    });

  };

  $scope.valueAssign = function (data) {
    if (data.body) {
      if (data.body.hasOwnProperty('formatedMessageInBlock'))
        return true;
    }
    if (data.obj && data.obj.body) {
      if (data.obj.body.hasOwnProperty('formatedMessageInBlock'))
        return true;
    }
  };

  $scope.sendPicture = function (messageData) {
    var value = atob(messageData)
    var jValue = JSON.parse(value)
    var message = { text: "Prueba de vida enviada.", url: jValue.ReferenceImage, type: "sent", layout: "end", format: "", typeDocument: "Image" }  //{text: response.data.url, url: blobUrl, type: "sent", layout: "end", format: format[1], typeDocument: "Image"}

    xmppAuth.Chat.sendMessageImage(xmppUser + "@" + xmpp_domain, "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain, message, value);
    $scope.metadataObj = undefined;
    console.log("Message sent");
    $sessionStorage.dataResult = undefined
  }
  if ($sessionStorage.dataResult && $sessionStorage.dataResult != 'success-logout' && !$sessionStorage.dataResult.token) {

    var dataResult = JSON.parse(atob($sessionStorage.dataResult))
    if (dataResult.error) {

    } else {
      $scope.sendPicture($sessionStorage.dataResult)
    }
  }
});
